import _ from "underscore";
import { datify, unixts } from "../utils/date";

export function cond(...tokens) {
    // throw out options
    return tokens.pop(), expr( tokens );
}

function expr(tokens) {
    let x = conjunction( tokens );
    while (tokens.length && tokens[0] == '|') {
        tokens.shift(); // throw out the first "or"
        if (!!conjunction( tokens )) x = true;
    }

    return x;
}

function conjunction(tokens) {
    let x = operation( tokens );
    while (tokens.length && tokens[0] == '&') {
        tokens.shift(); // throw out the first "and"
        if (!operation( tokens )) x = false;
    }

    return x;
}

function operation(tokens) {
    let x = operand( tokens );

    if (!['==', '===', '!=', '!==', '<=', '>=', '<', '>'].includes( tokens[0] ))
        return x;

    const op = tokens.shift();
    let y = operand( tokens );

    if (x instanceof Date || y instanceof Date)
        x = unixts( datify( x ) ),
        y = unixts( datify( y ) );

    switch (op) {
        case '==':  return x == y;
        case '===': return x === y;
        case '!=':  return x != y;
        case '!==': return x !== y;
        case '<=':  return x <= y;
        case '>=':  return x >= y;
        case '<':   return x < y;
        case '>':   return x > y
    }

    return x;
}

function calc(op, x, y) {

}

function operand(tokens) {
    if (tokens[0] === '!')
        return tokens.shift(), !operand( tokens );

    let x;
    if (tokens[0] === '(')
        return tokens.shift(), x = expr( tokens ), tokens.shift(), x;

    return tokens.shift();
}



// WEBPACK FOOTER //
// ./src/js/lib/handlebars.cond.js